import { FLINT } from 'HubStyleTokens/colors';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickFilterContainer = ({
  children,
  // For acceptance test
  filterName,
  onClear,
  shouldHighlight = false,
  shouldShowClearButton = false
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    flexShrink: 0,
    marginInlineStart: "300",
    children: /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsxs(Flex, {
        backgroundColor: shouldHighlight ? 'fill-info-subtle' : undefined,
        borderRadius: shouldHighlight ? '100' : undefined,
        alignItems: "center",
        "data-test-id": "filter-highlight",
        children: [children, shouldShowClearButton && /*#__PURE__*/_jsx(UIIconButton, {
          "data-selenium-test": `${filterName}-quick-filter-clear-button`,
          onClick: onClear,
          use: "transparent",
          size: "extra-small",
          className: "m-left-0",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "remove",
            color: FLINT
          })
        })]
      })
    })
  });
};
export default QuickFilterContainer;